export default __webpack_public_path__ + "static/media/togodo-logo.336aeb88.svg";